import clsx from 'clsx';
import {
  Children,
  cloneElement,
  ComponentProps,
  FC,
  HTMLAttributes,
  isValidElement,
} from 'react';

import { addCustomCopyBehavior } from 'src/utils/ClipboardUtils';

const listContainerStyles = 'list-outside pl-5 mt-0.5 mb-2 ml-2.5';

export const CustomUlComponent: FC = ({ children }) => (
  <ul
    className={clsx('list-disc', listContainerStyles)}
    {...addCustomCopyBehavior({
      isCopyContainer: true,
    })}
  >
    {children}
  </ul>
);

export const CustomOlComponent: FC<{ start?: number }> = ({
  start,
  children,
}) => {
  let validElementIndex = 0;

  return (
    <ol
      className={clsx(
        'list-decimal [&_ol]:list-[lower-alpha] [&_ol_ol]:list-[lower-roman] [&_li]:pl-1',
        listContainerStyles,
      )}
      start={start}
      {...addCustomCopyBehavior({
        isCopyContainer: true,
      })}
    >
      {Children.map(children, (child) => {
        if (
          isValidElement<ComponentProps<typeof CustomLiComponent>>(child) &&
          child.type === CustomLiComponent
        ) {
          const itemNumber = (start ?? 1) + validElementIndex;
          validElementIndex++;
          return cloneElement(child, { itemNumber });
        }
        return child;
      })}
    </ol>
  );
};

export const CustomLiComponent: FC<
  HTMLAttributes<HTMLLIElement> & { itemNumber?: number }
> = ({ itemNumber, children, ...props }) => (
  <li
    {...props}
    {...addCustomCopyBehavior({
      isCopyContainer: true,
      plaintextPrefix: `${itemNumber ? `${itemNumber}.` : '-'} `,
    })}
  >
    {children}
  </li>
);
